<!DOCTYPE html>
<template>
	<main id="main-content" class="container py-4">
		<create-user/>
	</main>
</template>

<style lang="scss" scoped>
</style>
<script>
	import "firebase/compat/auth";
	import "firebase/compat/firestore";
	import CreateUser from "@/components/create-user";
	import axios from "axios";
	const config = require("../firebaseconfig.js");

	class User {
		constructor () {
		
		}
	}
	export default {
		methods: {
			createUser() {
				if (this.password != this.confirmPassword) {
					alert("passwords do not match");
				} else {
					//ISSUE : newly created user changed to logged in user
					//Change to FCF, which uses Firebase Admin to create user
					var user = new User();
					user.firstName = this.firstName;
					user.middleName = this.middleName;
					user.lastName = this.lastName;
					user.birthdate = this.birthdate;
					user.prcId = this.prcId;
					user.fullAddress = this.fullAddress;
					user.roles = this.role;
					axios.post(config.functionBaseUrl + "/user", user)
						.then(response => {
							//TODO: update dashboard list
							return;
						}).catch(error => {
							alert("error " + error);
						}
					);
				}
			},
		},
		components: {'create-user': CreateUser},
		data() {
			return {
				uid: "",
				firstName: "",
				middleName: "",
				lastName: "",
				birthdate: null,
				fullAddress: "",
				prcId: "",
				email: "",
				password: "",
				confirmPassword: "",
				role: -1,
				error: "",
				userList: [],
			}
		}
	}
</script>

